import en from "./en"
import hr from "./hr"

const allTranslations = { hr: hr(), en: en() }
const _defaultLocale:PrivateProjects.Assets.Locale.Language = 'hr'

export default function getLocales(){
    const currentLocale = getCurrentLocale()
    return {
        lang: allTranslations[currentLocale]
    }
}

const STORAGE_KEY_LOCALE = 'current_locale'
export function getCurrentLocale(){
    const localeFromStorage = localStorage.getItem(STORAGE_KEY_LOCALE)
    if(!localeFromStorage){
        localStorage.setItem(STORAGE_KEY_LOCALE, _defaultLocale)
        return _defaultLocale
    }
    else{
        return localeFromStorage as PrivateProjects.Assets.Locale.Language
    }
}
export function setCurrentLocale(newLocale: PrivateProjects.Assets.Locale.Language){
    localStorage.setItem(STORAGE_KEY_LOCALE, newLocale)
}